// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"188":"0eb164b85057875d","638":"0e056240962bfab0"}[chunkId] + ".js";
};